module.exports = __webpack_public_path__ + "img/smap2.79ef84db.png";